export default __webpack_public_path__ + "static/media/question.fc0d9f9e.png";